import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScreenResizing } from '../../hooks/UI/useScreenResizing';
import debounce from 'lodash.debounce';
import './TravelWithAnimalsCheckbox.module.scss';
const animalItems = [
    { text: 'smallDog', class: 'small_dog', visible: true },
    { text: 'averageDog', class: 'middle_dog', visible: true },
    { text: 'bigDog', class: 'big_dog', visible: true },
    { text: 'cat', class: 'cat', visible: true },
    { text: 'raccoon', class: 'racoon', visible: true },
    { text: 'lessCat', class: 'smaller_animal', visible: true },
];
export const TravelWithAnimalsCheckbox = ({ suggest = false, setAmountOfClicksInCheckbox, amountOfClicksInCheckbox, animalSelected, checkedDot, setChecketDot, gbvcss, onChangeIsAnimalSelected, }) => {
    const [isChecked, setIsChecked] = useState(checkedDot);
    const [listOfAnimals, setListOfAnimals] = useState(animalItems);
    const [isAnimalSelected, setIsAnimalSelected] = useState(animalSelected);
    const [openAnimalList, setOpenAnimalList] = useState(false);
    const [selectedAnimals, setSelectedAnimals] = useState([]);
    const viewPort = useScreenResizing();
    const isDesktop = viewPort.width > 1199;
    const { t } = useTranslation('Calendar');
    useEffect(() => {
        const checkClose = e => {
            const checkAnimalInput = document.getElementById('block_checkbox_animal');
            const clickAnimInput = e.composedPath().includes(checkAnimalInput);
            if (!clickAnimInput && openAnimalList) {
                setOpenAnimalList(false);
                if (!selectedAnimals.includes(true)) {
                    const resetSelectedAnimals = selectedAnimals.map(() => false);
                    setSelectedAnimals(resetSelectedAnimals);
                }
            }
        };
        document.addEventListener('click', checkClose);
        return () => {
            document.removeEventListener('click', checkClose);
        };
    }, [openAnimalList, selectedAnimals]);
    useEffect(() => {
        onChangeIsAnimalSelected(isAnimalSelected);
    }, [isAnimalSelected, onChangeIsAnimalSelected]);
    useEffect(() => {
        if (!setChecketDot) {
            return;
        }
        setChecketDot(isChecked);
    }, [isChecked]);
    useEffect(() => {
        if (!gbvcss) {
            setIsAnimalSelected(false);
            setOpenAnimalList(false);
        }
    }, [gbvcss]);
    const onChangeInput = e => {
        setIsChecked(false);
    };
    useEffect(() => {
        if (!openAnimalList && !checkedDot) {
            setListOfAnimals(animalItems);
        }
    }, [openAnimalList, checkedDot]);
    const onClickOpenCheck = () => {
        setAmountOfClicksInCheckbox(amountOfClicksInCheckbox + 1);
        setOpenAnimalList(!openAnimalList);
    };
    const selectAnimal = (e, index) => {
        e.stopPropagation();
        const updatedSelectedAnimals = [...selectedAnimals];
        updatedSelectedAnimals[index] = true;
        setSelectedAnimals(updatedSelectedAnimals);
        setTimeout(() => {
            setOpenAnimalList(false);
        }, 1300);
        setTimeout(() => {
            setIsChecked(true);
        }, 1300);
    };
    const handleItemClick = itemId => {
        const updatedItems = listOfAnimals.map((item, index) => index === itemId ? Object.assign(Object.assign({}, item), { visible: true }) : Object.assign(Object.assign({}, item), { visible: false }));
        setListOfAnimals(updatedItems);
    };
    return (_jsxs(_Fragment, { children: [!isDesktop && (_jsxs("div", Object.assign({ id: "block_checkbox_animal", className: suggest ? 'block_checkbox_animal vertical-secondary-block' : 'block_checkbox_animal' }, { children: [_jsx("input", { type: "checkbox", id: "checkbox_animal", className: "checkbox_input_animal", onChange: onChangeInput, onClick: debounce(onClickOpenCheck, amountOfClicksInCheckbox > 0 ? 0 : 700) }), _jsx("label", Object.assign({ className: openAnimalList ? 'checked_label_animal' : !checkedDot ? 'checkbox_label' : 'checkbox_label_animal', htmlFor: "checkbox_animal" }, { children: t('travelingWithAnimals') })), _jsx("div", Object.assign({ style: { opacity: openAnimalList && !gbvcss ? 1 : 0, transition: 'opacity 250ms' }, className: "modal__backdrop_checkbox " }, { children: _jsx("div", Object.assign({ className: "block_checkbox_animal_window", id: "openChecked_window" }, { children: _jsx("ul", Object.assign({ className: "animal_window_ul", onClick: selectAnimal }, { children: listOfAnimals.map((item, index) => (_jsx("li", Object.assign({ style: { opacity: item.visible ? 1 : 0, transition: 'opacity 1500ms' }, onClick: () => handleItemClick(index), className: !isAnimalSelected ? `animal_window_li ${item.class}` : `animal_window_li_selected  ${item.class}` }, { children: t(`${item.text}`) }), index))) })) })) })), _jsx("div", Object.assign({ className: gbvcss ? 'gbvcss_notification' : 'notification__hidden' }, { children: _jsx("p", { children: t('rtbirwn&animals') }) }))] }))), isDesktop && (_jsxs("div", Object.assign({ id: "block_checkbox_animal", className: suggest ? 'block_checkbox_animal vertical-secondary-block' : 'block_checkbox_animal' }, { children: [_jsx("input", { type: "checkbox", id: "checkbox_animal", className: "checkbox_input_animal", onChange: onChangeInput, onClick: debounce(onClickOpenCheck, amountOfClicksInCheckbox > 0 ? 0 : 700) }), _jsx("label", Object.assign({ className: openAnimalList ? 'checked_label_animal' : !checkedDot ? 'checkbox_label' : 'checkbox_label_animal', htmlFor: "checkbox_animal" }, { children: t('travelingWithAnimals') })), _jsx("div", Object.assign({ className: openAnimalList && !gbvcss ? 'modal__backdrop_checkbox' : 'modal__backdrop_checkbox_notvisible' }, { children: _jsx("div", Object.assign({ className: "block_checkbox_animal_window", id: "openChecked_window" }, { children: _jsx("ul", Object.assign({ className: "animal_window_ul", onClick: selectAnimal }, { children: listOfAnimals.map((item, index) => (_jsx("li", Object.assign({ style: {
                                        opacity: item.visible ? 1 : 0,
                                        transition: 'opacity 1500ms',
                                    }, onClick: () => handleItemClick(index), className: !isAnimalSelected ? `animal_window_li ${item.class}` : `animal_window_li_selected  ${item.class}` }, { children: t(`${item.text}`) }), index))) })) })) })), _jsx("div", Object.assign({ className: gbvcss ? 'gbvcss_notification' : 'notification__hidden' }, { children: _jsx("p", { children: t('rtbirwn&animals') }) }))] })))] }));
};
